import { Grid } from '@mui/material';
import { memo } from 'react';
import {
  ForeignAddressVM,
  SubscriptionAireOperationVO,
} from 'practice/view-models/practice-detail';
import PmiTextField from 'shell/components/shared/text-field';
import { useParams } from 'react-router-dom';
import { TypeRegister } from 'practice/constants/type-register';
import { noop } from 'shell/utils/noop';
import { DatePicker } from '@mui/lab';

interface FormProps {
  disabled?: boolean;
  onChange: (key: keyof ForeignAddressVM, value: ForeignAddressVM[keyof ForeignAddressVM]) => void;
  values?: ForeignAddressVM;
  subscriptionAire?: SubscriptionAireOperationVO;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  subscriptionAire,
}: FormProps): React.ReactElement => {
  const params = useParams();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Stato estero"
          label="Stato estero"
          id="foreignState"
          name="foreignState"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.foreignState || ''}
          onChange={(event) => onChange('foreignState', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Comune"
          label="Comune"
          id="foreignMunicipality"
          name="foreignMunicipality"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.foreignMunicipality || ''}
          onChange={(event) => onChange('foreignMunicipality', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Provincia/Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.foreignProvince || ''}
          onChange={(event) => onChange('foreignProvince', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="CAP"
          label="CAP"
          id="cap"
          name="cap"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.cap || ''}
          onChange={(event) => onChange('cap', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Denominazione toponimo"
          label="Denominazione toponimo"
          id="toponymDenomination"
          name="toponymDenomination"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.toponymDenomination || ''}
          onChange={(event) => onChange('toponymDenomination', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Civico"
          label="Civico"
          id="civic"
          name="civic"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.civic || ''}
          onChange={(event) => onChange('civic', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Consolato"
          label="Consolato"
          id="consulate"
          name="consulate"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.consulate || ''}
          onChange={(event) => onChange('consulate', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Territorio"
          label="Territorio"
          id="territory"
          name="territory"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.territory || ''}
          onChange={(event) => onChange('territory', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      {params.tipoRegistro === TypeRegister.Emigration ? (
        <>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="subscription-number"
              label="Nr. Iscrizione AIRE Consolato"
              aria-label="Nr. Iscrizione AIRE Consolato"
              fullWidth
              onChange={noop}
              value={subscriptionAire?.number || ''}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data Iscrizione AIRE Consolato"
              aria-label="Data Iscrizione AIRE Consolato"
              value={subscriptionAire?.date || null}
              onChange={noop}
              disabled
              renderInput={(parameters) => (
                <PmiTextField {...parameters} id="dateSubscription" fullWidth helperText="" />
              )}
            />
          </Grid>
        </>
      ) : undefined}
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion address - form';

const Form = memo(FormComponent);

export default Form;
